import { useEffect } from 'react';
import axios from '../../../lib/axios';
import { logoutApi } from '../../../api/AuthenticationApi';

const Logout = () => {
    useEffect(() => {
        logoutApi().then(() => {
            window.location = '/login';
        });
    });

    return null;
};

export default Logout;
